/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import DataGridColumn from "./DataGridColumn";
import { FlexGridCellTemplate } from "@grapecity/wijmo.react.grid";
import { useEffect, useState } from "react";

import "../layout/DataGridApprovalStateColumn.css";
import TkFilesDownloadDialog from "../../dialogTypes/TkFilesDownloadDialog";
import FolderIcon from '@material-ui/icons/Folder';

function DataGridFilesDownloadColumn ( props ) {

    const { schema, ...others } = props;

    const [ , setDialog ] = useState ();
    const [ cellTemplate, setCellTemplate ] = useState ( ( ctx ) => {
        return <></>;
    } );
    
    const [ key, setKey ] = useState ();
    const [ pdfConf, setPdfConf ] = useState ();

    const onClick = ( ctx ) => {

        setKey(ctx.item[schema.grid.key]);

        setPdfConf( schema.grid.pdfConf ? schema.grid.pdfConf : "#toolbar=0&navpanes=0&scrollbar=0&view=FitH,0" );

        setDialog ( ( dialog ) => {

            if ( dialog ) {

                dialog.show ();

            }

            return dialog;

        } );

    }

    useEffect ( () => {

        setCellTemplate ( () => ( ( ctx ) => {

            if ( schema ) {

                return (

                    <>
                        {
                            ctx.item[schema.name]
                            ?
                            <span className="filesDownload" onClick={() => onClick ( ctx )} >

                                    <FolderIcon>download</FolderIcon>

                            </span>
                            :
                            <></>
                        }

                    </>

                );

            } else {

                return <></>;

            }

        } ) );

    }, [schema] );

    const onDialogInitialized = ( dialog ) => {

        setDialog ( dialog );

    }

    const onModifyViewUrl = ( url, key ) => {

        return url + "/" + key;

    }

    return (

        <DataGridColumn schema={schema} align="center" {...others} >
            <FlexGridCellTemplate cellType="Cell" template={cellTemplate} />
            <TkFilesDownloadDialog 
                view={schema.grid.view} 
                onInitialized={onDialogInitialized} 
                onModifyViewUrl={ ( url ) => onModifyViewUrl ( url, key)} 
                pdfConf={pdfConf}
                maxWidth={"lg"} 
                dialogTitle={schema.name}
            />
        </DataGridColumn>

    );

}

export default DataGridFilesDownloadColumn;